<div @opacityChanged class="errors-wrapper">
    <span class="error-text">{{textError}}</span>
</div>
